import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

function Banner({ data }) {
  const isMobile = useMediaQuery("(max-width:599px)");

  const [title, setTitle] = useState("");
  const [dateStart, setDateStart] = useState("");
  const [catalogDownload, setCatalogDownload] = useState("");
  const [catalogView, setCatalogView] = useState("");

  useEffect(() => {
    if (!data || !data.length) return;
    const options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
    try {
      const date = new Date(data[0].date_start);
      setTitle(data[0].auction_name);
      setCatalogDownload(data[0].catalog_download);
      setCatalogView(data[0].catalog_url);
      setDateStart(date.toLocaleDateString("en-US", options));
    } catch (err) { console.log(err); }
  }, [data]);

  // Design Constants
  const charcoal = "#333a40"; // Mas malambot kaysa sa pure black
  const lightGrayBg = "#f4f5f7"; // Subtle gray background

  const btnStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    textDecoration: "none",
    textTransform: "uppercase",
    fontWeight: 600,
    letterSpacing: "0.8px",
    borderRadius: "2px",
    transition: "all 0.2s ease",
    height: isMobile ? "36px" : "44px",
    fontSize: isMobile ? "11px" : "13px",
    padding: isMobile ? "0 15px" : "0 25px",
    minWidth: isMobile ? "110px" : "160px",
  };

  return (
    <section style={{ backgroundColor: lightGrayBg, borderBottom: "1px solid #e1e4e8" }}>
      <div style={{ 
        padding: isMobile ? "35px 20px" : "65px 20px", 
        textAlign: "center",
        maxWidth: "1000px",
        margin: "0 auto"
      }}>
        
        

        
        <h1 style={{
          fontSize: isMobile ? "24px" : "46px",
          fontWeight: 700,
          color: charcoal,
          margin: "0 0 12px 0",
          lineHeight: 1.2,
          fontFamily: "'Bell MT', serif",
        }}>
          {title}
        </h1>

        
        <p style={{ 
          fontSize: isMobile ? "14px" : "18px", 
          color: "#495057", 
          margin: "0 0 8px 0",
          fontWeight: 500 ,
          fontFamily: "'Bell MT', serif",
        }}>
          {dateStart}
        </p>
        
        
        <p style={{ 
          fontSize: isMobile ? "11px" : "13px", 
          color: "#6c757d", 
          maxWidth: "500px", 
          margin: "0 auto 30px auto",
          lineHeight: 1.5,
          fontWeight: 400,
          fontFamily: "'Bell MT', serif",
        }}>
          G/F Eurovilla 1, Rufino corner Legazpi Street, Makati City
        </p>

        
        <div style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: isMobile ? "10px" : "15px",
          flexWrap: "wrap",
                fontFamily: "'Bell MT', serif",
        }}>
          
          <a
            href={catalogView}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              ...btnStyle,
              backgroundColor: charcoal,
              color: "#fff",
              fontFamily: "'Bell MT', serif",
            }}
          >
            <OpenInNewIcon style={{ fontSize: "14px" }} />
            E-Catalog
          </a>

          
          <a
                 href={`/pdf/${catalogDownload}.pdf`} // may leading slash
            download
            style={{
              ...btnStyle,
              backgroundColor: "transparent",
              color: charcoal,
              fontFamily: "'Bell MT', serif",
              border: `1.5px solid ${charcoal}`,
            }}
          >
            <DownloadIcon style={{ fontSize: "14px" }} />
            {isMobile ? "PDF" : "Download PDF"}
          </a>
        </div>
      </div>
    </section>
  );
}

export default Banner;